import type { RootState } from '@/root-store';
import {
  createUploadSlice,
  createUploadSliceUtils,
} from '@/shared/store/doc-uploader/create-upload-slice';

import { partnerAPI } from '../api';
import { PartnerDocType } from '../model/partner-doc-type';

import { getPartnerId, getUploadedDocsForPartner } from './selectors';

const partnerUploadNamespace = 'partnerDocUpload';

const partnerUploadSlice = createUploadSlice<PartnerDocType>(
  'user_agreement',
  partnerUploadNamespace,
);

const { selectors: partnerUploadSelectors, asyncActions: partnerUploadAsyncActions } =
  createUploadSliceUtils({
    namespace: partnerUploadNamespace,
    eventTrackingType: 'company',
    actionSetBusy: partnerUploadSlice.actions.setPending,
    selectHolderId: getPartnerId,
    selectUploadedDocs: getUploadedDocsForPartner,
    uploadFile: partnerAPI.uploadFile,
    getSliceState: (state: RootState) => state[partnerUploadNamespace],
  });

export {
  partnerUploadSlice,
  partnerUploadSelectors,
  partnerUploadAsyncActions,
  partnerUploadNamespace,
};
